import { EMPTY_FILTERS } from "@/hooks/useListingSearch";

const CONDITIONS = ["", "new", "used", "refurbished"];
const SORTS = [["newest", "Newest"], ["price_asc", "Price: Low → High"], ["price_desc", "Price: High → Low"], ["popular", "Most Viewed"]];
const smallInput = "border-2 border-black px-2 py-1 font-mono-data text-sm rounded-none focus:outline-none focus:ring-2 focus:ring-[#0000EE]";

function FilterGroup({ label, children }) {
  return (
    <fieldset className="mb-4">
      <legend className="font-mono-data text-xs uppercase font-bold mb-2">{label}</legend>
      {children}
    </fieldset>
  );
}

export function FiltersPanel({ filters, onChange, open }) {
  const update = (key) => (e) => onChange({ ...filters, [key]: e.target.value });
  return (
    <aside className={`${open ? "block" : "hidden"} md:block md:col-span-3 border-2 border-black p-4 bg-[#F9F9F9] h-fit md:sticky md:top-[80px]`} data-testid="filters-sidebar">
      <div className="font-mono-data text-xs uppercase border-b border-black pb-2 mb-3 font-bold">/ Filters</div>
      <FilterGroup label="Price">
        <div className="flex gap-2">
          <input data-testid="filter-min-price" type="number" placeholder="Min" value={filters.min_price} onChange={update("min_price")} className={`w-1/2 ${smallInput}`} />
          <input data-testid="filter-max-price" type="number" placeholder="Max" value={filters.max_price} onChange={update("max_price")} className={`w-1/2 ${smallInput}`} />
        </div>
      </FilterGroup>
      <FilterGroup label="Location">
        <input data-testid="filter-location" type="text" placeholder="city or zip" value={filters.location} onChange={update("location")} className={`w-full ${smallInput}`} />
      </FilterGroup>
      <FilterGroup label="Condition">
        {CONDITIONS.map((c) => (
          <label key={c || "any"} className="flex items-center gap-2 font-mono-data text-xs uppercase cursor-pointer py-0.5">
            <input data-testid={`filter-cond-${c || "any"}`} type="radio" name="cond" value={c} checked={filters.condition === c} onChange={update("condition")} className="accent-[#0000EE]" />
            {c || "Any"}
          </label>
        ))}
      </FilterGroup>
      <FilterGroup label="Sort By">
        <select data-testid="filter-sort" value={filters.sort} onChange={update("sort")} className={`w-full ${smallInput} bg-white`}>
          {SORTS.map(([v, label]) => <option key={v} value={v}>{label}</option>)}
        </select>
      </FilterGroup>
      <button data-testid="filter-clear" onClick={() => onChange(EMPTY_FILTERS)} className="w-full bg-white border-2 border-black px-3 py-2 font-mono-data text-xs uppercase hover:bg-black hover:text-white">Clear All</button>
    </aside>
  );
}
